module.exports = __webpack_public_path__ + "img/378.b3974736.png";